import { Link, useLocation } from 'react-router-dom';

interface Props {
  open: boolean,
  handleLogoutModalOpen: () => void
}

// const myImageRelease = false;

const SideBar = ({ open, handleLogoutModalOpen }: Props) => {
  const location = useLocation();
  const isActive = (path: string) => (location.pathname === path ? 'active' : '');

  return (
    <nav id="sidebar" className="sidebar js-sidebar" style={{ marginLeft: open ? '0px' : '-260px' }}>
      <div className="sidebar-content js-simplebar">
        <Link className="sidebar-brand text-center" to="/" style={{ height: '65px', background: '#fff' }}>
          <img src="/img/logo.png" alt="ビルドセルフ - BUILD-SELF" className="img-fluid" width="200" />
        </Link>
        <ul className="sidebar-nav" style={{ overflowY: 'auto' }}>
          <li className="sidebar-header">
            メインメニュー
          </li>
          <li className={`sidebar-item ${isActive('/')}`}>
            <Link className="sidebar-link" to="/">
              <i className="fa-solid fa-house fa-fw" />
              {' '}
              <span className="align-middle">ホーム</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/me')}`}>
            <Link className="sidebar-link" to="me">
              <i className="fa-solid fa-pen-to-square fa-fw" />
              {' '}
              <span className="align-middle">マイページ</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/user-sites')}`}>
            <Link className="sidebar-link" to="user-sites">
              <i className="fa-solid fa-sitemap fa-fw" />
              {' '}
              <span className="align-middle">サイト管理</span>
            </Link>
          </li>
          <li className="sidebar-header py-0">
            <hr />
          </li>

          <li className="sidebar-header pt-0">
            管理
          </li>

          <li className={`sidebar-item ${isActive('/my-blocks-management')}`}>
            <Link to="/my-blocks-management" className="sidebar-link">
              <i className="fa-solid fa-cubes fa-fw" />
              {' '}
              <span className="align-middle">マイブロック管理</span>
            </Link>
          </li>

          {/* {myImageRelease && ( */}
          <li className={`sidebar-item ${isActive('/my-images-management')}`}>
            <Link className="sidebar-link" to="/my-images-management">
              <i className="fa-regular fa-image fa-fw" />
              {' '}
              <span className="align-middle">マイ画像管理</span>
            </Link>
          </li>
          {/* )} */}
          <li className={`sidebar-item ${isActive('/my-videos-management')}`}>
            <Link className="sidebar-link" to="/my-videos-management">
              <i className="fa-solid fa-video fa-fw" />
              {' '}
              <span className="align-middle">マイ動画管理</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/inquiry-management')}`}>
            <Link className="sidebar-link" to="/inquiry-management">
              <i className="fa-solid fa-file-signature fa-fw" />
              {' '}
              <span className="align-middle">お問合せ管理</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/files')}`}>
            <Link className="sidebar-link" to="/files">
              <i className="fa-regular fa-file fa-fw" />
              {' '}
              <span className="align-middle">ファイル管理</span>
            </Link>
          </li>

          <li className="sidebar-header py-0">
            <hr />
          </li>

          <li className="sidebar-item" onClick={handleLogoutModalOpen}>
            <a href="#" className="sidebar-link">
              <i className="fa-solid fa-door-open fa-fw" />
              {' '}
              <span className="align-middle">ログアウト</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default SideBar;
